import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

class DropzoneAction {
    constructor(args) {
        let self = this;
        self._setArgs(args);

        self._init();
    };

    _elems = {
        $_          : $()
    };

    _args = {
        actions  : {},
        dropzone : {},
        file     : {},
        entity   : '',
        done     : function() {}
    };

    _state = {};

    _setArgs = (args) => {
        let self = this;

        self._args.actions  = args.actions;
        self._args.dropzone = args.dropzone;
        self._args.file     = args.file;
        self._args.entity   = args.entity;
        self._args.done     = args.done || self._args.done;
    };

    _render = () => {
        let self = this;

        if (!Object.keys(self._args.actions).length) return;

        let $file = $(self._args.file._removeLink).parent();
        if (!$file.length) return;

        Object.keys(self._args.actions).forEach(function(key){
            const action = self._args.actions[key];
            let $action = $();
            if (action.isLink) {
                $action = $('<a/>').attr('href', '#');
            } else if (action.isInput) {
                $action = $('<input/>');
            }

            if (action.confirmation) {
                $action.addClass('with-confirmation');
            }

            if (key == 'remove') {
                $action.addClass('dz-' + key);
                $action.html('<i class="fa fa-close" />');

                $action.on('click', function(e){
                    e.preventDefault();
                    self._bindRemove({action : action});
                });
            }
            else if (key == 'rotate90'){
                $action.addClass('dz-rotate-90');
                $action.html('<i class="fa fa-rotate-right" />');

                $action.on('click', function(e){
                    e.preventDefault();
                    self._bindRotate({action : action});
                });
            }
            else if (key == 'rotate270'){
                $action.addClass('dz-rotate-270');
                $action.html('<i class="fa fa-rotate-left" />');

                $action.on('click', function(e){
                    e.preventDefault();
                    self._bindRotate({action : action});
                });
            }
            else if (key == 'name'){
                $action.addClass('no-hidden dz-input').attr('placeholder', 'название').val(action.value(self._args.file));
                $action.change(function() {
                    loader.increase();

                    Request.send({
                        path   : action.url(self._args.file),
                        method : 'POST',
                        data   : action.data($action),
                        done   : function(response) {
                            loader.decrease();
                            action.done(response);
                        }
                    });
                }).on('keydown', function(e) {
                    if (e.which !== 13) return;
                    e.preventDefault();
                    $(this).blur();
                });
            }

            $action.appendTo($file);
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$_ = !self._elems.$_.length ? $('.content') : self._elems.$_;
        if(!self._elems.$_.length) return;
    };

    _bindRemove = (args) => {
        let self = this;

        let action = args.action;
        if (!action) return;

        new Modal({
            title   : action.args.title,
            content : Utils.renderProfileTemplate('removing-confirmation', {
                args: action.args
            }),
            confirm : function(args) {
                self._args.dropzone.removeFile(self._args.file);
                let $modal = args.modal;
                if (!$modal.length) return;
                $modal.trigger('close');
            }
        });
    };

    _bindRotate = (args) => {
        let self = this;

        let action = args.action;
        if (!action) return;

        let $file = $(self._args.file._removeLink).parent();
        if (!$file.length) return;

        $file.removeClass('dz-complete').addClass('dz-processing');

        Request.send({
            path: action.url(self._args.file),
            data: action.data,
            done: function(response) {
                self._args.file[self._args.entity] = response['cloned_' + self._args.entity];
                $file.find('.dz-image').css('background-image', 'url(\'/' + ( self._args.file[self._args.entity].path_to_small != '' ? self._args.file[self._args.entity].path_to_small : self._args.file[self._args.entity].path_to_original ) + '\')');
                $file.find('input').val(self._args.file[self._args.entity].id );
                if(self._args.file[self._args.entity].path_to_extra_large != '') {
                    $file.find('.dz-link').attr('href', self._args.file[self._args.entity].path_to_extra_large);
                } else {
                    $file.find('.dz-link').attr('href', self._args.file[self._args.entity].path_to_original);
                }
                $file.removeClass('dz-processing').addClass('dz-complete');

                let file = { name: '', size: 1 };
                file[self._args.entity] = self._args.file[self._args.entity];

                self._args.done(file);
            }
        });
    };

    _init = () => {
        let self = this;

        self._render();
    }
}

export default DropzoneAction;